var components;
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('uni-rich-text',_vm._g({},_vm.$listeners),[_c('div',{ref:"content"},[_c('v-uni-resize-sensor',{ref:"sensor",on:{"resize":function($event){return _vm._updateView()}}})],1)])}
var recyclableRender = false
var staticRenderFns = []

export { render, staticRenderFns, recyclableRender, components }